import CartSteps from './frontoffice/CartSteps';
customElements.define('cart-steps', CartSteps,{extends: 'div'});
